import { useEffect, useState } from "react";
import {
  TUpdateAttributePayload,
  useSocketClient,
} from "../contexts/SocketClientProvider";
import { IScene } from "../features/scenes/types";

export const useSceneAttribute = (scene: IScene, attribute: "status") => {
  const [value, setValue] = useState(scene[attribute]);
  const socketClient = useSocketClient();
  useEffect(() => {
    const callback = (payload: TUpdateAttributePayload) => {
      if (payload.type === "scene" && payload.id === scene.id) {
        if (payload.attribute === attribute) {
          setValue(payload.value);
        }
      }
    };
    socketClient.subscribe(callback, "update_attribute");
    return () => socketClient.unsubscribe(callback, "update_attribute");
  }, [scene, attribute, socketClient]);

  return value;
};
